<template>
<div id="app">
    <!--顶部nav-->
    <!-- <div class="topCommon">
      <div class="logo">
        <img src="@/assets/images/logo.png" alt="" />
      </div>
    </div> -->
    <div v-if="false">
      <div class="topBox" style="height:auto">
        <div class="typeBox">
          <img src="@/assets/images/zsy_icon_01.png" alt="" style="transform: none;cursor: auto;"/>
          <img
            src="@/assets/images/0445_03.jpg"
            alt=""
            @click="jump('index')"
          />
          <img
            src="@/assets/images/0445_05.jpg"
            alt=""
            @click="jump('szyw')"
          />
          <img
            src="@/assets/images/0445_09.jpg"
            alt=""
            @click="jump('gfjj')"
          />
          <img
            src="@/assets/images/0445_11.jpg"
            alt=""
            @click="jump('hyss')"
          />
          <img
            src="@/assets/images/0445_13.jpg"
            alt=""
            @click="jump('qyqcss')"
          />
          <img
            src="@/assets/images/0445_15.jpg"
            alt=""
            @click="jump('sgcy')"
          />
          <img
            src="@/assets/images/0445_17.jpg"
            alt=""
            @click="jump('kjcy')"
          />
          <img
            src="@/assets/images/0445_19.jpg"
            alt=""
            @click="jump('ssyh')"
          />
          <img
            src="@/assets/images/0445_07.jpg"
            alt=""
            @click="jump('jckss')"
          />
        </div>
      </div>
      <div style="width: 100%; background: #f5f5f5; padding: 20px 0 0 0">
        <div class="banner">
          <img src="@/assets/images/00_banner_1200px_120px.png" alt="" />
          <!-- <img src="@/assets/images/btn.png" alt="" @click="drawer = true" style="cursor: pointer;"> -->
        </div>
      </div>
    </div>
    <div class="midCommon">
      <div style="padding-bottom:50px">
    <div class="contentBox">
      <div class="title" v-html="data.title"></div>
      <div class="text" v-html="imgUrl(data.text)">
      </div>
      <div style="padding-top:16px;border-top:2px solid #d8d8d8;font-size:18px;color:#3d3d3d" v-if="listId == 4023">提示：本文章仅供学习参考，如有侵权请联系删除。</div>
      <div style="padding-top:16px;border-top:2px solid #d8d8d8;font-size:18px;color:#3d3d3d" v-if="listId == 4027">提示：该答复仅供参考。</div>
      <div class="typeBoxs" v-if="data.FilesInfo&&data.FilesInfo.length>0">
        <div class="accessory">
          <span style="margin-left:14px"> 附件:</span>
        </div>
        <div class="titleBox" v-for="item in data.FilesInfo" @click="download(item.contentFilePath)">
          <span class="title">{{item.title}}</span>
          <span class="btn" style="cursor: pointer;">下载</span>
        </div>
      </div>
      <div class="typeBoxs" v-if="data.JDInfo&&data.JDInfo.length>0">
        <div class="accessory">
          <span style="margin-left:14px">相关解读:</span>
        </div>
        <div class="titleBox" v-for="item in data.JDInfo" @click="jumpC(item.id)">
          <span class="title" style="cursor: pointer;">{{item.title}}</span>
        </div>
      </div>
    </div>
  </div>
    </div>
    <!-- <div class="footCommon">网站版权信息</div> -->
  </div>
  
</template>

<script>
import { Cmsdetail,HomeAnalyzeKeyword } from "@/api/api";
export default {
  data(){
    return{
      nav:true,
      type:[ '有效文件',
             '失效文件',
             '部分失效',
             '-',
             '时效性文件',],
      id:this.$route.query.contentId,
      keyWord:this.$route.query.keyWord,
      data:{},
      loading:'',
      that:this,
      tag:[],
      listId:this.$route.query.listId
    }
  },
  created(){
    this.HomeAnalyzeKeyword()
    setTimeout(()=>{
       this.Cmsdetail()
    },1000)
   
  },
  filters:{
    publishDate(v){
      var date = new Date(v);//时间戳为10位需*1000，时间戳为13位的话不需乘1000
      var Y = date.getFullYear() + '-';
      var M = (date.getMonth()+1 < 10 ? '0'+(date.getMonth()+1) : date.getMonth()+1) + '-';
      var D = (date.getDate() < 10 ? '0'+(date.getDate()) : date.getDate()) + ' ';
      var h = (date.getHours() < 10 ? '0'+(date.getHours()) : date.getHours()) + ':';
      var m = (date.getMinutes() < 10 ? '0'+(date.getMinutes()) : date.getMinutes()) + ':';
      var s = (date.getSeconds() < 10 ? '0'+(date.getSeconds()) : date.getSeconds());
      return Y+M+D;
      //return Y+M+D+h+m+s;
    },
    typeFil(v,that){
      return that.type[(v-1)];
    },
  },
  methods:{
    jump(v) {
      let url = process.env.VUE_APP_ZSG_URL+v;
      window.open(url,'_blank')
    },
    imgUrl(v){
      let a = v;
      let b = new RegExp('src=\"/webfile/',"g")
      if(v){
        a = a.replace(b,'src=\"http://zsdy-data-admin.bjzsdy.com/webfile/');
      }
      return a
    },
    download(v){
      if(v){
        let src = process.env.VUE_APP_DOWNLOAD_URL+v
        var $a = document.createElement('a');
        $a.setAttribute("href", src);
        $a.setAttribute("download", "");
        var evObj = document.createEvent('MouseEvents');
        evObj.initMouseEvent( 'click', true, true, window, 0, 0, 0, 0, 0, false, false, true, false, 0, null);
        $a.dispatchEvent(evObj);
      }else{
        this.$message({
          message: '当前附件未上传可下载文件！！！',
          type: 'warning'
        });
      }
    },
    jumpC(v){
      let Detail = this.$router.resolve({path:'/content',query:{contentId:v,keyWord:this.keyWord,contentIds:this.contentIds}})
      window.open(Detail.href,'_blank')
    },
        HomeAnalyzeKeyword(){
      this.tag = [];
      let data = {
      keyword:this.keyWord
      }
      HomeAnalyzeKeyword(data).then(res => {
        console.log(res.data.data,"dddd");
       this.tag = res.data.data
      })
    },
    Cmsdetail(){
      this.loading = this.$loading({
          lock: true,
          text: '拼命加载中',
          spinner: 'el-icon-loading',
          background: 'rgba(0, 0, 0, 0.7)'
        });
      let data = {
        moduleName:'gw',
        id:this.id+'',
        keyWords:''
        // keyWords:this.tag.length==0?[this.keyWord.trim()]:this.tag
      }
      if(this.tag != false){
        data.keyWords = this.tag
      }else{
        data.keyWords = [this.keyWord.trim()]
      }
      if(this.$route.query.searchType == 3){
        data.articleNo = this.keyWord.trim()
      }
      Cmsdetail(data).then(res => {
        console.log(res);
        this.data = res.data.data  
         let that = this
         setTimeout(function () {
       
            //描蓝 法规跳法规
            that.$nextTick(function () {
              that.addStyle();
            });
          }, 300);
        this.loading.close();
      })
    },
      addStyle() {
      let that = this; //debugger
      let changeDiv = document.getElementsByClassName("goto-article");
      if (changeDiv && changeDiv.length != 0) {
        Array.from(changeDiv).forEach((item) => {
          item.style.color = "blue";
          item.style.cursor = "pointer";
          item.style.textDecoration = "underline";
          item.onclick = function () {
            let str = { id: "" ,keyWord:this.keyWord};
            str.id = item.getAttribute("data-goto-article-id"); //获取节点属性
            that.goDetail(str);
          };
        });
      }
    },
     goDetail(item) {
      let routeData = this.$router.resolve({
        path: "/content",
        query:{
        contentId:item.id+'',
        keyWord:this.keyWord 
        }
      });
      window.open(routeData.href, "_blank");
    },
  }
}
</script>

<style lang="scss" scoped>
.contentBox{
  width: calc(1200px - 240px);
  // height: calc(1340px - 70px);
  background: #fff;
  margin: 0 auto;
  padding: 35px 120px 35px;
  .title{
    line-height: 36px;
    // width: 790px;
    text-align: center;
    color: #3d3d3d;
    font-size: 18px;
    font-weight: 700;
  }
  .more{
    // height: 92px;
    margin: 20px 0;
    .time{
      color: #888;
      line-height: 24px;
      font-size: 16px;
      margin-bottom: 10px;
    }
    .time:last-child{
      margin-bottom: 0;
    }
  }
  .text{
    padding-top: 16px;
    border-top: 2px solid #d8d8d8;
    font-size: 16px;
    font-weight: normal;
    line-height: 32px;
    letter-spacing: 0em;
    color: #3D3D3D;
    padding-bottom: 40px;
  }
  .typeBoxs{
    .accessory{
      width: 100%;
      height: 40px;
      line-height: 40px;
      border-left: 6px solid #003fa8;
      background: #EEF8FF;
      font-size: 16px;
      font-weight: bold;
      letter-spacing: 0em;
      color: #3D3D3D;
      margin-bottom: 15px;
    }
    .titleBox{
      width: calc(100% - 11px);
      padding-left: 11px;
      // height: 30px;
      margin-bottom: 10px;
      .title{
        font-size: 16px;
        font-weight: normal;
        line-height: 30px;
        letter-spacing: 0em;
        color: #0000FF;
      }
      .btn{
        width: 60px;
        height: 30px;
        font-size: 14px;
        font-weight: normal;
        line-height: 30px;
        letter-spacing: 0em;
        color: #fff;
        border-radius: 4px;
        background: #003FA8;
        display: inline-block;
        text-align: center;
        float: right;
        
      }
    }
  }
}

::v-deep .text img{
    width: 100%;
}
::v-deep .text table{
    width: 100%;
    border-color: #dfdfdf;
    border-collapse: collapse;
    float: none;
}
::v-deep .text table tr td{
    text-align: center;
    padding:0.5rem 0;
    border-color: #dfdfdf;
    border:1px solid #dfdfdf;
}
</style>